import { nanoid } from 'nanoid';
import { parseAsArrayOf, parseAsJson } from 'nuqs';
import { z } from 'zod';

export const queryParam = 'panes';

const queryStateSchema = z.object({
  id: z.string(),
  key: z.string(),
  type: z.union([
    z.literal('activityThread'),
    z.literal('userWorkflowDocument'),
    z.literal('aiFollowups'),
    z.literal('allCases'),
    z.literal('creditReport'),
    z.literal('customTerms'),
    z.literal('dataReference'),
    z.literal('documentRequestUser'),
    z.literal('documentRequestUserFile'),
    z.literal('followupHistory'),
    z.literal('formRequest'),
    z.literal('invoice'),
    z.literal('previewDocument'),
    z.literal('formRequestTemplate'),
    z.literal('workflowTemplate'),
    z.literal('userWorkflowDocuments'),
    z.literal('helpCenter'),
  ]),
});

export type QueryStateSchema = z.infer<typeof queryStateSchema>;

export const queryStateParser = parseAsArrayOf(parseAsJson(queryStateSchema.parse)).withOptions({ history: 'push' });

export const backwardsCompatabilityFactory = ({ type, id }: {
  id: string;
  type: QueryStateSchema['type'];
}) => (state: QueryStateSchema[] | null): QueryStateSchema[] | null => {
  const hasThis = Boolean(state?.find(s => s.type === type && s.id === id));
  if (!state || !hasThis) {
    return [...(state || []), { id, key: nanoid(), type }];
  }

  return state;
};
